module.exports = __webpack_public_path__ + "static/img/img_gift01.jpg";